// src/redux/selectors/network/friendshipSelectors.ts
import { RootState } from "../../storeTypes";

// General loading, error, success
export const selectFriendshipLoading = (state: RootState) => state.friendship.loading;
export const selectFriendshipError = (state: RootState) => state.friendship.error;
export const selectFriendshipSuccessMessage = (state: RootState) => state.friendship.successMessage;

// Data selectors
export const selectFriendshipSearchResults = (state: RootState) => state.friendship.searchResults;
export const selectFriendshipSentRequests = (state: RootState) => state.friendship.sentRequests;
export const selectFriendshipReceivedRequests = (state: RootState) => state.friendship.receivedRequests;
export const selectFriendsList = (state: RootState) => state.friendship.friendsList;
export const selectFriendsSuggestions = (state: RootState) => state.friendship.friendsSuggestions;
export const selectRequestsSuggestions = (state: RootState) => state.friendship.requestsSuggestions;


export const selectFriendshipSearchPage = (state: RootState) => state.friendship.searchPage;
export const selectFriendshipSearchNext = (state: RootState) => state.friendship.searchNext;
export const selectFriendshipSearchTotalCount = (state: RootState) => state.friendship.searchTotalCount;


// People suggestions for Square People
export const selectPeopleSuggestions = (state: RootState) =>
  state.friendship.peopleSuggestions;

export const selectPeopleNext = (state: RootState) =>
  state.friendship.peopleNext;

export const selectPeoplePage = (state: RootState) =>
  state.friendship.peoplePage;